import { VpButton } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { useMatch, useNavigate } from 'react-router'
import { NoResultsIllustration } from '@/components/NoResultsIllustration'

export function NoResults() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const exactSeasonMatch = useMatch('/:season')
  const deepSeasonMatch = useMatch('/:season/*')
  const season = (deepSeasonMatch ?? exactSeasonMatch)?.params?.season

  return (
    <div className="quick-search__no-results">
      <NoResultsIllustration />
      <div className="quick-search__no-results__content">
        <h2>{t('results-not-found')}</h2>
        <p>{t('no-results-search-descr')}</p>
      </div>
      <VpButton
        onClick={() => navigate(season ? `/${season}` : '/')}
        variant="primary"
        size="small"
      >
        {t('quick-search.back-to-universes')}
      </VpButton>
    </div>
  )
}
